module.exports = __webpack_public_path__ + "static/media/pov_vertex_figure_Dodecahedron.b92ce3a8.png";